// Domínio da equipe interna. Só e-mails deste domínio veem as ferramentas de
// diagnóstico (downloads, lease, fila de sync) — aluno comum nem vê as opções.
const INTERNAL_EMAIL_DOMAIN = ['@pagtrust.com.br', '@voxeldigital.com.br', '@gufum.com'];

export default {
  computed: {
    $currentUser () {
      return this.$store.state.user.currentUser
    },

    // Gate das ferramentas de diagnóstico. NÃO é controle de segurança: só
    // esconde UI de suporte/debug de quem não é da equipe. Case-insensitive
    // porque o e-mail pode vir com capitalização variada do backend.
    $isInternalUser () {
      const email = this.$store.state.user.currentUser && this.$store.state.user.currentUser.email;
      return typeof email === 'string' && INTERNAL_EMAIL_DOMAIN.some(domain => email.trim().toLowerCase().endsWith(domain));
    },

    $profilePic () {
      return this.$store.state.user.currentUser.studentPhoto;
    },

    $firstLetter(){
      return this.$store.state.user.currentUser.studentName ? this.$store.state.user.currentUser.studentName.substr(0,1).toUpperCase() : ''
    }
  }
}
